module.exports = __webpack_public_path__ + "img/qr-code_icon.2959404d.png";